document.addEventListener('DOMContentLoaded', function () {
    const header_height = 62;
  const s = document.getElementById('sticky-filter');
  const initialStickyFilterPos = s.getBoundingClientRect().top + window.scrollY;
    let initialStickyFilterPosition; 
    let stickyFilter_position; 
    let isExpanded = false; 
    const w = window.innerWidth;
    let expandPos = 0;
    let initExpand = false;
    function updateStickyFilterPosition() {
        const sticky = document.getElementById('sticky-filter');
        
            initialStickyFilterPosition = sticky.getBoundingClientRect().top + window.scrollY;
            stickyFilter_position = initialStickyFilterPosition;       
    }

      function updateExpandPosition() {
        const sticky = document.getElementById('sticky-filter');
            const expand = sticky.getBoundingClientRect().top + window.scrollY;
            expandPos = expand;
    }

    function handleScroll() {
        const placeholder = document.getElementById('sticky-filter-placeholder');
        const stickyFilter = document.getElementById('sticky-filter');

        if (stickyFilter) {
            const scrollPosition = window.scrollY;
            placeholder.style.height = stickyFilter.offsetHeight + 24 + 'px';

            if (scrollPosition >= stickyFilter_position - header_height) {
                stickyFilter.classList.add('sticky-filter-active');
                if (w <= 767) {                
                    placeholder.style.display = 'block';
                }
            } else {
                stickyFilter.classList.remove('sticky-filter-active');
                if (w <= 767) {
                    placeholder.style.display = 'none';               
                }
            }
        }
    }

    window.addEventListener('scroll', handleScroll);

    const targetNode = document.getElementById('ProductGridContainer');
    const config = { childList: true, subtree: true };

    const observer = new MutationObserver(function () {
      const stickyEl = document.getElementById('sticky-filter');
      const isSticky = stickyEl.classList.contains('sticky-filter-active');
      if(isSticky){
        if(isExpanded){
          stickyFilter_position = expandPos;
        }
        else{
        stickyFilter_position = initialStickyFilterPos; 
        }
        handleScroll();
      }
      else{
        updateStickyFilterPosition(); 
        handleScroll();
      }
    });

    if (targetNode) {
        observer.observe(targetNode, config);
    }

    const toggleButton = document.querySelector('.toggle-description');
    if (toggleButton) {
        toggleButton.addEventListener('click', function () {
            isExpanded = !isExpanded;
            
            if (isExpanded) {
                setTimeout(function () {
                    if(!initExpand){
                    updateExpandPosition();
                      initExpand = true;
                    }
                    updateStickyFilterPosition(); 
                    handleScroll(); 
                }, 300); 
            } else {
                stickyFilter_position = initialStickyFilterPos; 
                handleScroll(); 
            }
        });
    }

    updateStickyFilterPosition(); 
    handleScroll(); 
});
